import React from 'react';
import type { IHighlight } from 'react-pdf-highlighter';
import { PdfViewer } from './PdfViewer';
import { DocumentViewer } from './DocumentViewer';
import type { Cuepoint } from '../types';

export interface TabWrapperProps {
  document: any;
  index: number;
  pdfViewerRef: React.MutableRefObject<never>;
  highlights: IHighlight[] | null;
  cuepoints: Cuepoint[] | null;
}

export const TabWrapper = ({
  document,
  index,
  pdfViewerRef,
  highlights,
  cuepoints,
}: TabWrapperProps) => {
  const isPdf = document?.name.toLocaleLowerCase().endsWith('.pdf');
  const isPrimary = index === 0;

  return (
    <div
      style={{
        overflowY: 'auto',
        height: 'calc(100vh - 120px)',
      }}
    >
      {isPdf ? (
        <PdfViewer
          url={document.path}
          ref={isPrimary ? pdfViewerRef : null}
          highlights={isPrimary ? highlights : null}
          cuepoints={isPrimary ? cuepoints : null}
          isPrimary={isPrimary}
        />
      ) : (
        <DocumentViewer url={document.path} />
      )}
    </div>
  );
};
